import $ from 'jquery';

$.fn.socialShareButton = function(customOptions) {
  var title = document.title;
  var description = $('meta[name="description"]');
  var ogTitle = $('meta[property=\'og:title\']').attr('content');
  var ogDescription = $('meta[property=\'og:description\']').attr('content');
  var ogImage = $('meta[property=\'og:image\']').attr('content');
  if (!title.length && ogTitle && ogTitle.length) {
    title = ogTitle;
  }
  if (!description.length && ogDescription && ogDescription.length) {
    description = ogDescription;
  } else {
    description = description.attr('content');
  }

  if (!document.location.origin) {
    document.location.origin = document.location.protocol + "//" + document.location.hostname;
  }
  var options = $.extend({
    title: title,
    description: ogDescription && ogDescription.length ? ogDescription : description,
    image: ogImage && ogImage.length ? ogImage : '',
    url: document.location.origin + document.location.pathname,
    onClick: function() {}
  }, customOptions);
  var socialList = {
    vk: {
      shareUrl: '//vk.com/share.php?url=[URL]&title=[TITLE]&description=[DESC]&image=[IMAGE]&noparse=true',
      counterUrl: '//vk.com/share.php?act=count&index=1&url='
    },
    fb: {
      shareUrl: '//www.facebook.com/sharer/sharer.php?u=[URL]',
      counterUrl: '//graph.facebook.com/'
    },
    ok: {
      shareUrl: '//www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl=[URL]&st.comments=[TITLE]',
      counterUrl: '//connect.ok.ru/dk?st.cmd=extLike&uid=odklcnt0&ref='
    },
    tw: {
      shareUrl: '//twitter.com/share?url=[URL]&text=[TITLE]'
    },
    gp: {
      shareUrl: '//plus.google.com/share?url=[URL]'
    }
  }
  var getDataFromSocial = function(url) {
    return $.ajax({
      url: url,
      crossDomain: true,
      dataType: 'jsonp'
    });
  }
  var increaseCounter = function() {
    var $counter = $(this).find('.js_social_counter');
    if ($counter.length) {
      $counter.text(parseInt($counter.text()) + 1);
    }
  }
  var handleClick = function(prefix) {
    return function() {
      var pageUrl = $(this).attr('data-url');
      var url = socialList[prefix].shareUrl;
      url = url.replace(/\[URL\]/g, encodeURIComponent(pageUrl && pageUrl.length ? pageUrl : options.url));
      url = url.replace(/\[TITLE\]/g, encodeURIComponent(options.title));
      url = url.replace(/\[DESC\]/g, encodeURIComponent(options.description));
      url = url.replace(/\[IMAGE\]/g, encodeURIComponent(options.image));
      window.open(url, 'displayWindow', 'width=700, height=400, left=200, top=100, location = no, directories = no, status = no, toolbar = no, menubar = no');
      increaseCounter.apply(this);
      if (typeof options.onClick === 'function') {
          options.onClick(prefix);
      }
    }
  }
  var getCounters = function(prefix, data) {
    var that = this;
    return function() {
      var handleRequest = function() {};
      var handleCounterData = function(index, count) {
        $(that).find('.js_social_counter').html(count);
      }
      if (prefix === 'vk') {
        window.VK = window.VK || {}
        window.VK.Share = window.VK.Share || {};
        window.VK.Share.count = handleCounterData;
      } else if (prefix === 'ok') {
        window.ODKL = window.ODKL || {}
        window.ODKL.updateCount = handleCounterData;
      } else if (prefix === 'fb') {
        handleRequest = function(data) {
          var counter = (data && data.shares) ? data.shares : 0;
          handleCounterData(0, counter);
        }
      }
      getDataFromSocial(data.counterUrl + options.url).done(handleRequest);
    }
  }
  this.each(function(index, el) {
    var prefix = $(el).attr('data-social');
    var data = socialList[prefix];
    if (!data) {
      return;
    }
    $(this).on('click', handleClick(prefix));
    !!$(this).attr('data-social-counter') && data.counterUrl && getCounters.call(this, prefix, data)();
  })
}

export default function() {
  $('.js_social').socialShareButton();
}